import { render, staticRenderFns } from "./PanelContainer.vue?vue&type=template&id=63a5e104&scoped=true"
import script from "./PanelContainer.vue?vue&type=script&lang=js"
export * from "./PanelContainer.vue?vue&type=script&lang=js"
import style0 from "./PanelContainer.vue?vue&type=style&index=0&id=63a5e104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5e104",
  null
  
)

export default component.exports